import { render, staticRenderFns } from "./optionFormer.vue?vue&type=template&id=446be188&"
import script from "./optionFormer.vue?vue&type=script&lang=js&"
export * from "./optionFormer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports